import {isFiltered, numberWithSpaces} from "./functions";

function bestBoundWithTimeLimit(result, timeLimit) {
    if (result.length === 0)
        return false;
    for (let i = result.length - 1; i >= 0; i--)
        if (result[i].time <= timeLimit)
            return result[i];
    return false;
}


function computeBestBoundWithTimeLimit(benchmark, selectedSolvers, data, filters, i, limit) {
    let best = false
    let optim = false
    let unsat = false
    for (let s of selectedSolvers) { // Find best score
        const result = data[s.id][i]

        if (result === undefined || result.bug === 1 ||  isFiltered(filters, result) === false)
            continue;
        if(unsat || is_unsat(result)) {
            unsat = true
            continue
        }
        let bound = bestBoundWithTimeLimit(result.bounds, limit)
        if (bound === false)
            continue
        optim = optim || (data[s.id][i].time !== -1 && data[s.id][i].time < filters.timeLimit)
        if (best === false || (benchmark.type.startsWith("max") && bound.bound > best) || (benchmark.type.startsWith("min") && bound.bound < best))
            best = bound.bound
    }
    return [best, optim, unsat]
}

function createCOPScoreBest(selectedSolvers, data, benchmarks, filters) {
    let tmp = [];
    for (let i = 0; i < selectedSolvers.length; i++)
        if (data[selectedSolvers[i].id] === undefined)
            return []


    for (let i = 0; i < benchmarks.length; i++) {
        if (isFiltered(filters, benchmarks[i]) === false)
            continue;
        let sz = benchmarks[i].name.length;
        let n = sz > 30 ? benchmarks[i].name.substring(0, 10) + " ... " + benchmarks[i].name.substring(sz - 10, sz) : benchmarks[i].name
        let current = {
            id: benchmarks[i].id,
            name: benchmarks[i].name,
            nb_variables: benchmarks[i].nb_variables,
            nb_constraints: benchmarks[i].nb_constraints,
            type: benchmarks[i].type,
            info_domains: benchmarks[i].info_domains,
            useless_vars: benchmarks[i].useless_vars,
            info_constraints: benchmarks[i].info_constraints,
            family: benchmarks[i].family,
            bound: {
                time: benchmarks[i].best_bound === null && benchmarks[i].optim ? "UNSAT" :  benchmarks[i].best_bound === null ? "--" : numberWithSpaces(benchmarks[i].best_bound),
                classes: benchmarks[i].optim ? "optim" : null
            }
        }
        let [bestBound, optim] = computeBestBoundWithTimeLimit(benchmarks[i], selectedSolvers, data, filters, i, filters.timeLimit)
        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j];
            let d = data[s.id][i]
            if (d === undefined) {
                current[s.name + " " + s.version] = "--";
            } else {
                if(d.unsupported == "1") {
                    current[s.name + " " + s.version] = {time: 'U (' + 0 + ")<br>&nbsp;"}
                } else {
                    if ((d.time === -1 && d.bounds.length === 0)) // No bounds
                        current[s.name + " " + s.version] = {time: '(' + 0 + ")<br>&nbsp;", classes: d.bug === 1 ? "conflict":"bad"}
                    else {
                        let bestbound = bestBoundWithTimeLimit(d.bounds, filters.timeLimit)
                        // New score for competition XCSP22
                        let score = 0
                        if (d.time !== -1 && d.time < filters.timeLimit)
                            score = 1
                        else {
                            if (optim && bestbound.bound === bestBound)
                                score = 0.5
                            else if (bestbound.bound === bestBound)
                                score = 1
                        }
                        if(d.bug === 1)
                            score = 0
                        let res = ( bestbound === false ? "" : numberWithSpaces(Math.ceil(bestbound.time) + "s"))
                            + (d.time !== -1 && d.time < filters.timeLimit ? " - " + numberWithSpaces(Math.ceil(d.time)) + "s" : "")
                        current[s.name + " " + s.version] = {
                            time: (bestbound === false  && d.time !== -1 && d.time < filters.timeLimit ? "UNSAT" : (bestbound === false ? "" : numberWithSpaces(bestbound.bound))) + ' (' + score + ")<br>" + res,
                            classes: d.bug === 1 ? "conflict" : (d.time !== -1 && d.time < filters.timeLimit) ? "optim" : (score == 0 ? "bad" : 0)
                        }
                    }
                }
            }
        }
        tmp.push(current);
    }
    return tmp


}


function createCOPScore(selectedSolvers, data, benchmarks, filters) {
    if (filters.scoringMethod === "BEST")
        return createCOPScoreBest(selectedSolvers, data, benchmarks, filters)


    const alpha = 0.5
    let intervals
    if (filters.scoringMethod === "DECREASING")
        intervals = [1, 10, 60, 120, 300, 600, 2000]
    if (filters.scoringMethod === "LINEAR") {
        intervals = [1]
        for (let i = 1; i <= 40; i++)
            intervals.push(i * 50)
    }


    let tmp = [];

    for (let i = 0; i < selectedSolvers.length; i++)
        if (data[selectedSolvers[i].id] === undefined)
            return []


    for (let i = 0; i < benchmarks.length; i++) {
        if (isFiltered(filters, benchmarks[i]) === false)
            continue;
        let sz = benchmarks[i].name.length;
        let n = sz > 30 ? benchmarks[i].name.substring(0, 10) + " ... " + benchmarks[i].name.substring(sz - 10, sz) : benchmarks[i].name
        let current = {
            id: benchmarks[i].id,
            name: n,
            nb_variables: benchmarks[i].nb_variables,
            nb_constraints: benchmarks[i].nb_constraints,
            info_domains: benchmarks[i].info_domains,
            useless_vars: benchmarks[i].useless_vars,
            info_constraints: benchmarks[i].info_constraints,
            family: benchmarks[i].family,
            type: benchmarks[i].type,
            bound: {
                time: benchmarks[i].best_bound === "undefined" ? "--" : benchmarks[i].best_bound,
                classes: benchmarks[i].optim ? "optim" : null
            }
        };


        // the min/max bounds found by all solvers
        let min = false
        let max = false

        // Add the pseudo bound that associates the optimiality
        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j]
            if (data[s.id][i].time === -1 || data[s.id][i].bug === 1)
                continue
            let bounds = data[s.id][i].bounds
            let best
            if (benchmarks[i].type.startsWith("min"))
                best = bounds[bounds.length - 1].bound - 1
            if (benchmarks[i].type.startsWith("max"))
                best = bounds[bounds.length - 1].bound + 1
            data[s.id][i].bounds.push({time: data[s.id][i].time, bound: best})

        }

        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j]
            let bounds = data[s.id][i].bounds
            if (data[s.id][i].bug === 1 || (data[s.id][i].time === -1 && bounds.length === 0))
                continue
            if (benchmarks[i].type.startsWith("min") && (max === false || bounds[0].bound > max))
                max = bounds[0].bound
            if (benchmarks[i].type.startsWith("max") && (min === false || bounds[0].bound < min))
                min = bounds[0].bound

            if (benchmarks[i].type.startsWith("min") && (min === false || bounds[bounds.length - 1].bound < min))
                min = bounds[bounds.length - 1].bound
            if (benchmarks[i].type.startsWith("max") && (max === false || bounds[bounds.length - 1].bound > max))
                max = bounds[bounds.length - 1].bound
        }

        let bestBounds = []

        // Best bounds in intervals
        for (let limit of intervals) {
            if (limit > filters.timeLimit)
                break
            let tmp = computeBestBoundWithTimeLimit(benchmarks[i], selectedSolvers, data, filters, i, limit)
            bestBounds.push(tmp === false ? false : tmp)
        }


        // the time where every one found the best value
        let lastTime = 0 // store the index

        for (let k = 0; k < intervals.length; k++) {
            lastTime++
            let nb = 0
            let limit = intervals[k]
            for (let j = 0; j < selectedSolvers.length; j++) {
                let s = selectedSolvers[j];
                let b_i = data[s.id][i].bug === 1 ? false : bestBoundWithTimeLimit(data[s.id][i].bounds, limit).bound
                if (benchmarks[i].type.startsWith("min") && b_i === min)
                    nb++
                if (benchmarks[i].type.startsWith("max") && b_i === max)
                    nb++
            }
            if (nb === selectedSolvers.length)
                break
        }

        /*        let lastTime = 0 // store the index
                let worstOptimTime = 0
                for (let j = 0; j < selectedSolvers.length; j++) {
                    let s = selectedSolvers[j];
                    if(data[s.id][i].time === -1)
                        worstOptimTime = Number.MAX_VALUE
                    else
                    if(data[s.id][i].time > worstOptimTime)
                        worstOptimTime = data[s.id][i].time
                }

                for(let limit of intervals)
                    if(limit < filters.timeLimit && worstOptimTime >= limit)
                        lastTime++
        */

        let firstTime = 0
        for (let k = 0; k < intervals.length; k++) {
            let nb = 0
            let limit = intervals[k]
            for (let j = 0; j < selectedSolvers.length; j++) {
                let s = selectedSolvers[j];
                let b_i = data[s.id][i].bug === 1 ? false : bestBoundWithTimeLimit(data[s.id][i].bounds, limit).bound
                if (b_i === undefined)
                    nb++
            }
            if (nb !== selectedSolvers.length)
                break
            firstTime++
        }


        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j];
            console.log("ici", data[s.id][i])
            if (data[s.id][i] === undefined || data[s.id][i].bug === 1) {
                current[s.name + " " + s.version] = "--";
            } else {
                if (data[s.id][i].time === -1 && data[s.id][i].bounds.length === 0) // No bounds
                    current[s.name + " " + s.version] = {time: 0}
                else {

                    // Compute my bounds
                    //let bounds = []

                    let scores = []
                    for (let k = firstTime; k < lastTime; k++) {
                        let limit = intervals[k]
                        if (limit > filters.timeLimit)
                            break
                        let b_i = bestBoundWithTimeLimit(data[s.id][i].bounds, limit).bound

                        if (b_i === undefined)
                            scores.push(0)
                        else {
                            if (b_i === bestBounds[k])
                                scores.push(1)
                            else {
                                let r = Math.abs(max - min) / Math.abs(b_i - bestBounds[k])
                                /*
                                                               let s_i
                                                               if (r < 0.0001)
                                                                    s_i = 1
                                                                else if (r < 0.001)
                                                                    s_i = 0.75
                                                                else if (r < 0.01)
                                                                    s_i = 0.5
                                                                else if (r < 0.1)
                                                                    s_i = 0.25
                                                                else
                                                                    s_i = 0.1
                                */
                                let s_i = Math.min(Math.log10(r, 4) / 4)
                                scores.push(alpha * s_i)
                            }
                        }
                    }
                    let nbPoints = intervals.length - firstTime
                    if (scores.length === 0)
                        scores.push(0)
                    let score = parseFloat((Math.round(scores.reduce((accumulator, currentValue) => accumulator + currentValue) * (intervals.length / nbPoints) * 100) / 100).toFixed(2))
                    current[s.name + " " + s.version] = {
                        time: score,
                        classes: (data[s.id][i].time !== -1 && data[s.id][i].time < filters.timeLimit) ? "optim" : null
                    }
                }
            }
        }
        tmp.push(current);
        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j]
            if (data[s.id][i].time === -1)
                continue
            data[s.id][i].bounds.pop()
        }
    }
    return tmp;
}

function is_unsat(result) {
    return result.time > -1 && result.bounds.length === 0
}

export {isFiltered, bestBoundWithTimeLimit, computeBestBoundWithTimeLimit, createCOPScore, is_unsat};